var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _vm.products.length > 0
          ? _c(
              "div",
              { staticClass: "products" },
              _vm._l(_vm.products, function (product) {
                return _c("div", { staticClass: "prod_info" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2 px-2 p-1",
                    },
                    [
                      _c("div", { staticClass: "d-flex flex-row pt-2 pb-1" }, [
                        _c("span", { staticClass: "status" }, [
                          _c("img", {
                            staticClass:
                              "profile-image rounded-circle d-inline-block",
                            attrs: { src: product.image },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "position-absolute remove",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.remove_item(product)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "btn btn-danger btn-sm btn-icon waves-effect waves-themed",
                              },
                              [_c("i", { staticClass: "fal fa-times" })]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "user_attrib ml-3" }, [
                          _c(
                            "div",
                            { staticClass: "name d-block fw-700 text-dark" },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(product.title) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "company small text-dark" },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(product.price) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "clr" }),
                    ]
                  ),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("product_modal_list", {
        attrs: {
          selected_ids: _vm.active_products_ids,
          show_trigger: _vm.show_trigger,
          push_trigger_list: _vm.push_trigger,
          is_multiple: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }